module.exports = __webpack_public_path__ + "static/il-ticket-e70181269e76059508816ec84ce03eca.png";